import React from 'react';
import Avatar from '@mui/material/Avatar';
import { type FC, useMemo, type ReactNode } from 'react';

interface AvatarProps {
  id: string;
  children?: ReactNode;
  variant?: 'circular' | 'rounded' | 'square';
  alt?: string;
  src?: string;
  className?: string;
  width?: number;
  height?: number;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void; // Update onClick type
}

const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const CustomAvatar: FC<AvatarProps> = ({
  id,
  children,
  className,
  variant = 'circular',
  alt = '',
  src = '/broken-image.jpg"',
  width,
  height,
  onClick, // Destructure onClick
  ...rest
}) => {
  let backgroundColor = '';
  if (alt) {
    backgroundColor = useMemo(() => getRandomColor(), []);
  }

  return (
    <Avatar
      id={id}
      variant={variant}
      alt={alt}
      src={src}
      sx={{ bgcolor: backgroundColor, width: width, height: height }}
      className={className}
      onClick={onClick} // Pass onClick to Avatar
      {...rest}
    >
      {children}
    </Avatar>
  );
};

export default CustomAvatar;
